import Home from "../LandingHome/index";
import FreshMint from "../LandingFreshMint/index";
import Platform from "../LandingPlatform/index";
import SaleAndRent from "../LandingSaleAndRent/index";
import HowItWorks from "../LandingHowItWorks/index";
import Survey from "../LandingSurvey/index";
import Gallery from "../LandingGallery/index";
import Features from "../LandingFeatures/index";
import TechSpecs from "../LandingTechSpecs/index";
import CrossPlatform from "../LandingCrossPlatform/index";
// import TechOverview from "../TechOverview/index";


export {
	Home,
	FreshMint,
	Platform,
	SaleAndRent,
	HowItWorks,
	Survey,
	Gallery,
	Features,
	TechSpecs,
	CrossPlatform,
	// TechOverview,
};


// WEBPACK FOOTER //
// ./src/components/LandingBlockWrapper/index.js